import { TAILWIND_BREAKPOINTS } from '@egw/constants'
import { useEffect, useState } from 'react'

const debounce = (callbackFn: (_args?: unknown) => void, delay: number) => {
  // Declare a variable called 'timer' to store the timer ID
  let timer: ReturnType<typeof setTimeout>

  // Return an anonymous function that takes in any number of arguments
  return function debouncedFunction(...args: unknown[]) {
    // Clear the previous timer to prevent the execution of 'mainFunction'
    clearTimeout(timer)

    // Set a new timer that will execute 'mainFunction' after the specified delay
    timer = setTimeout(() => {
      callbackFn(...args)
    }, delay)
  }
}
// Register a callback to window.onresize event and auto-unsubscribe it on component unmount
export function useOnWindowResize(callback: () => void): void {
  useEffect(() => {
    const onResize = debounce(callback, 100)
    window.addEventListener('resize', onResize)
    onResize()

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [callback])
}

// Is the current screen mobile? (Tailwind screen "md" or less)
// Updated on window resize
export function useIsMobileScreen(): boolean {
  const [isMobileScreen, setIsMobileScreen] = useState<boolean>()

  useOnWindowResize(() => {
    setIsMobileScreen(window.innerWidth < TAILWIND_BREAKPOINTS.md)
  })

  return Boolean(isMobileScreen)
}
